/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import * as moment from 'moment';

import {OBJECT_TYPE} from '../../../../app/common/constants/object-type';
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {AuthHttpBufferService} from '../../../auth/auth-http-buffer.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the Notification HTTP resource (factory product). */
export class NotificationResource {
}

export function createNotificationResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  authHttpBuffer: AuthHttpBufferService
): any {
  function NotificationModel(this: any, props: any) {
    _.assign(this, props);
    this.time = moment(this.time);
    this.objectType = _.get(OBJECT_TYPE, this.objectType, {
      stateName: '.'
    });
  }

  NotificationModel.prototype.equals = function(other: any) {
    return this.id === other.id;
  };

  const url = ApiConfig.obtain().getVersionedUri('notifications');

  return {
    query: function(since: any, success: any): void {
      const minDate = moment.utc().subtract(28, 'd');
      const notifSince = moment(since).isBefore(minDate) ? minDate : since;

      const config = authHttpInterceptor.request({
        method: 'GET',
        url: url,
        params: {
          since: notifSince && notifSince.toJSON ? notifSince.toJSON() : notifSince
        },
        headers: {}
      });

      AdnHttp.request(config).then((response: any) => {
        success(_.map(response.data.results, (notification: any) => new (NotificationModel as any)(notification)));
      }, (response: any) => {
        if (response.status === 401) {
          authHttpBuffer.notifyLoginRequired(response);
        }
        if (!response.data && (response.status === -1 || response.status === 0)) {
          return;
        }
        ApiErrorHandler.responseError(response);
      });
    }
  };
}

export const notificationResourceProvider = {
  provide: NotificationResource,
  useFactory: createNotificationResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, AuthHttpBufferService]
};

